import styled from "styled-components";

export const InquiryCancelModalStyle = styled.div`

`;
